// @ts-nocheck
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

const Minus: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path fillRule="evenodd" clipRule="evenodd" fill="currentColor" d="M19 13H5a1 1 0 110-2h14a1 1 0 110 2z" />
        </svg>
    );
};

export const MinusOffset: IconOffset = {
    vertical: 0,
    horizontal: 18,
};

export default React.memo(Minus);
